import { mount } from "svelte";
import * as Sentry from "@sentry/svelte";
import App from "./App.svelte";
import "./style.css";

Sentry.init({
    dsn: "https://42837995e3304f91825b805b451bf1f0@o4505139576832000.ingest.us.sentry.io/4505523546357760",
    enableLogs: true,
});

const app = mount(App, {
    target: document.getElementById("app")!,
});

export default app;
